import { AppState } from '../models/AppState';

export const selectProductListQuery = (state: AppState): string =>
    state.productList.query.search;
